var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',[_vm._v("MEBUKI")]),(_vm.authStatus)?_c('div',{attrs:{"id":"nav"}},[_c('div',[_vm._v(_vm._s(_vm.user.name))]),_c('button',{staticClass:"auth-button",on:{"click":_vm.logOut}},[_vm._v(" Log Out")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }